
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText, CircularProgress } from '@mui/material';
import styled, { inputStyles, cutDates } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSingleTransportBail, updateTransportBailEntry } from '../../Store/PHPSlice/Transport/transportBail';
import { useParams } from 'react-router-dom';
import { selectBalelist, selectParty, selectTransports, selectChanllanId, selectClothIsInfo, selectClothIssue, selectCutReturnlist, selectEmployees, selectFirm, selectItemAvg, selectItems, selectMasterMlist, selectMemoNo, selectSONOinfolist } from '../Selectors/Master/ItemSelectors';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { errorStyles } from '../../Utils/table';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';

import { fetchTransportData } from '../../Store/PHPSlice/Transport';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const TransportBailEdit = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        id: parseInt(Id),
        transId: '',
        firmId:'',
        partyId: '',
        totalbail: '',
        lrno: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        firmId:fetchCompanyData,
        partyId: fetchPartyData,
        transId: fetchTransportData
        // Add more mappings if needed
    };
    const [gQty, setGQty] = useState([]);

    const [loading, setLoading] = useState(false);

    const transportlist = useSelector(selectTransports);
    const partylist = useSelector(selectParty);
    const firmlist = useSelector(selectFirm);

    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const singleBail = useSelector((state) => state.transportBail.singleBail || { data: [] });
    useEffect(() => {
        dispatch(fetchSingleTransportBail(Id));
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchTransportData());
    }, [dispatch, Id]);
    //   console.log("id=>",Id);
    useEffect(() => {
        if (singleBail.data.length > 0) {
            const item = singleBail.data[0];
            setFormData({
                ...formData,
                transportBailId: parseInt(Id),

                dt: item.dt,
                firmId:item.firmId,
                firmNm:item.firmNm,
                partyId: item.partyId,
                partyNm: item.partyNm,
                transId: item.transportId,
                transportNm: item.transportNm,
                lrno: item.lrno,
                totalbail: item.totalbail

            });
        }
    }, [singleBail]);
    // console.log("singlebail=>", singleBail)
    if (!singleBail) {
        return <h1>Loading...</h1>
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        // console.log(formData);
        // Validate department name
        // if (!formData.rackNm.trim()) {
        //     setErrors({ rackNm: 'Rack Name is required' });
        //     return;
        // }
        setLoading(true);

        try {
            const result = await dispatch(updateTransportBailEntry(formData)).unwrap();
            //  console.log('POST request successful!', result);
            alert("Transport Bail Details Updated Successfully....");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };




    const dropdownEmployeelist = [
         {
        label: 'Firm Name',
        id: 'firmId',
        options: firmlist?.data,
        value: formData.firmId,
        onChange: (newValue) =>
            handleDropdownChange(
                { target: { name: 'firmId', value: newValue ? newValue.ID : '' } },
                'firmId'
            ),
        getOptionLabel: (option) => option.firmNm || '',
        isOptionEqualToValue: (option, value) => option.ID === value,
        valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
        btnlabel: '',
        handleDropdownOpen: () => handleDropdownOpen('firmId'),
        handleDropdownClose: () => handleDropdownClose('firmId'),
    },
        {
            label: 'Party Name',
            id: 'partyId',
            options: partylist?.data,
            value: formData.partyId,
            onChange: (newValue) =>
                handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value,
            valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
            handleAddNew: () => handleNewParty(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('partyId'),
            handleDropdownClose: () => handleDropdownClose('partyId'),
        },

        {
            label: 'Transport Name',
            id: 'transId',
            options: transportlist?.data,
            value: formData.transId,
            onChange: (newValue) =>
                handleDropdownChange({ target: { name: 'transId', value: newValue ? newValue.ID : '' } }, 'transId'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value,
            valueFinder: (options, value) => options?.find(i => i.ID === value) || null,
            handleAddNew: () => handleNewTransport(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('transId'),
            handleDropdownClose: () => handleDropdownClose('transId'),
        }
    ];

    const handleNewParty = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleNewTransport = () => {
        window.open(`/NewTransportEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    }

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleDropdownChange = (e, fieldName) => {
        const { value } = e.target;

        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };



    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Transport Bail Entry</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}




                                {/* <Grid item xs={12} md={6}>

                                </Grid> */}

                                {/* {[
                                { label: 'Barcode', name: 'barcd', type: 'barcd' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input, readOnly: true }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))} */}










                                {
                                    dropdownEmployeelist && dropdownEmployeelist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }
                                {[

                                    { label: 'Total Bail', name: 'totalbail' },
                                    { label: 'LR No', name: 'lrno' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* {
                                    dropdownMemberlist  && dropdownMemberlist ?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }   */}



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default TransportBailEdit;
